// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TableCard {\n  overflow: hidden;\n}\n\n.TableCard__Title {\n  font-size: 1rem;\n  text-transform: capitalize;\n  font-weight: 500;\n  padding: 1.5rem !important;\n}", ""]);
// Exports
module.exports = exports;
